import React, { useContext } from 'react'
import { graphql, StaticQuery } from 'gatsby'

import StoreContext from '~/context/StoreContext'
import { Brevier, DoublePica } from '~/components/Typography'
import LineItem from './LineItem'
import { Container, Header, HeaderItem, Items, Footer, Button, FooterLabel } from './styles'
import ArrowDown from '~/icons/arrow-down.svg'
import nanoid from 'nanoid'
import fbTrack from '~/utils/fb'

const Cart = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)

  const handleCheckout = () => {
    fbTrack('track', 'InitiateCheckout', {currency: 'DKK', value: checkout.totalPrice})
    window.open(checkout.webUrl)
  }
  
  const line_items = checkout.lineItems.map(line_item => {
    return <LineItem key={line_item.id.toString()} line_item={line_item} />
  })

  return (
    <>
      <StaticQuery
        query={graphql`
          query Query {
            site {
              siteMetadata {
                currencyCode
              }
            }
          }
        `}
        render={({
          site: {
            siteMetadata: { currencyCode },
          },
        }) => (
          <Container>
            <Header>
              {['Produkt', 'Pris', 'Antal', 'Total'].map(item => (
                <HeaderItem key={nanoid()}>
                  <Brevier fontWeight={'300'}>{item}</Brevier>
                </HeaderItem>
              ))}
            </Header>
            <Items>{line_items}</Items>
            <Footer>
              <DoublePica>
                <FooterLabel>Forsendelse</FooterLabel> <span>GRATIS</span>
              </DoublePica>
              <DoublePica>
                <FooterLabel>Total</FooterLabel> <span>{checkout.totalPrice} {currencyCode}</span>
              </DoublePica>
              <DoublePica>
                <small>Rabatkoder kan anvendes ved kassen</small>
              </DoublePica>
              <Button tag={'button'} onClick={handleCheckout}>
                Videre til kassen <ArrowDown />
              </Button>
            </Footer>
          </Container>
        )}
      />
    </>
  )
}

export default Cart
